<header
  class="flex justify-between h-[61px] z-0 relative bg-[var(--header-primary-color)] text-[var(--text-primary)] border-b-[1px] border-[var(--header-border)] items-center"
  [ngClass]="{ 'px-[9%]': !isAdmin || (isAdmin && isPreviewMode) }"
>
  @if (isAdmin && !isPreviewMode) {
    <div class="flex items-center justify-start mr-2">
      <svg-icon
        class="mx-6 cursor-pointer"
        name="three_lines"
        size="LG"
        color="var(--text-primary)"
        (click)="collapseMenu()"
      ></svg-icon>

      @if (logoId) {
        <div class="max-h-[48px] cursor-pointer flex items-center">
          <image [id]="logoId" [props]="'max-h-[48px]'"></image>
        </div>
      }

      <h1 class="text-xl font-bold ml-5">{{ moduleName }}</h1>
    </div>
  } @else {
    <div class="flex gap-2 items-center h-[61px]">
      @if (!logoId) {
        <img
          class="h-[76%] w-auto cursor-pointer"
          routerLink="/home"
          [src]="'./../../../assets/logo/logo_full.png'"
          alt="logo"
        />
      }
      @if (logoId) {
        <div class="h-[76%] w-auto cursor-pointer" routerLink="/home">
          <image [id]="logoId"></image>
        </div>
      }
      <span class="text-lg text-nowrap text-[var(--text-primary)]">{{ title }}</span>
    </div>
  }

  @if (isMobile$ | async) {
    <div
      class="flex flex-row flex-nowrap gap-2 items-center"
      #mobileMenuWrapper
      tabindex="10"
      (click)="toggleMenu()"
      (keypress)="({})"
    >
      <svg-icon class="cursor-pointer" name="three_lines" size="LG" color="var(--text-primary)"></svg-icon>

      @if (showMenu) {
        <ul
          class="absolute z-100 flex flex-col min-w-[70vw] h-[calc(100vh_-_60px)] top-[61px] right-0 bg-[var(--header-primary-color)] px-4 pb-2 z-10"
        >
          <div class="flex flex-col gap-2 mb-2 relative">
            <div class="md:pt-[61px] my-2 col-span-2">
              @if (role === 'Admin' || role === 'User') {
                <div class="text-center my-2">
                  <p class="font-bold text-sm text-nowrap">{{ accountName }}</p>
                  <p
                    class="text-xs italic"
                    [ngClass]="{
                      'text-[var(--accent-warning)]': membershipStatus === 'ATTENTION' && status !== 4,
                      'text-[var(--accent-error)]': membershipStatus === 'GRACE_ZONE',
                      'text-[var(--accent-success)]': membershipStatus === 'ACTIVE' || status === 4,
                    }"
                  >
                    {{ currentMembership ? currentMembership.membership.title : role }}
                  </p>
                  <div class="w-fit mx-auto mt-2" (click)="$event.stopPropagation()" (keypress)="({})">
                    @if (role === 'Admin' && timezoneSelectionEnabled() && timezoneOptions().length > 1) {
                      <dropdown
                        size="S"
                        label="Timezone Selected"
                        [options]="timezoneOptions()"
                        [keys]="timezoneKeys"
                        [control]="timezoneControl"
                      ></dropdown>
                    } @else {
                      <div class="text-xs text-[var(--text-nav-secondary)] flex-col gap-2">
                        <span>Timezone: </span> <span>{{ currentTimezoneLabel() }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
              <hr />
            </div>

            @for (route of routes; track route.route) {
              <p [routerLink]="['/' + route.route]" class="cursor-pointer text-lg text-nowrap">
                {{ route.name }}
              </p>
            }

            <hr />

            <ul class="col-span-2">
              @for (item of displayedOptions; track item.action; let i = $index) {
                <li
                  class="flex items-center font-medium py-1 first-of-type:pt-0 last-of-type:pb-0 last-of-type:border-0"
                  (click)="performAction(item.action)"
                  (keypress)="performAction(item.action)"
                  [tabindex]="i"
                >
                  @if (item.icon) {
                    <svg-icon class="mr-2" [name]="item.icon" size="SM" color="var(--text-primary)"></svg-icon>
                  }
                  {{ item.option }}
                </li>
              }
            </ul>

            @if (role === 'Non-Authorized') {
              <p
                routerLink="/login"
                class="cursor-pointer justify-center text-lg flex flex-row flex-nowrap text-nowrap items-center gap-1"
              >
                Log In
                <svg-icon name="avatar_user_2" size="MD" color="var(--text-primary)"></svg-icon>
              </p>
            }
          </div>
        </ul>
      }
    </div>
  } @else {
    <div class="flex flex-row gap-3">
      @if (!isAdmin || (isAdmin && isPreviewMode)) {
        <div class="flex items-center gap-2 sm:gap-4 xl:gap-6">
          @for (route of routes; track route.route) {
            <p [routerLink]="['/' + route.route]" class="cursor-pointer text-lg text-nowrap">
              {{ route.name }}
            </p>
          }

          @if (role === 'Non-Authorized') {
            <p
              routerLink="/login"
              class="cursor-pointer text-lg flex flex-row flex-nowrap text-nowrap items-center gap-1"
            >
              Log In
              <svg-icon name="avatar_user_2" size="MD" color="var(--text-primary)"></svg-icon>
            </p>
          }
        </div>
      }

      @if (role === 'Admin' || role === 'User') {
        <div class="flex items-center gap-2">
          @if (role === 'Admin' && timezoneSelectionEnabled() && timezoneOptions().length > 1) {
            <span class="text-xs text-[var(--text-nav-secondary)]">Timezone Selected:</span>
            <dropdown
              size="M"
              class="min-w-[120px]"
              [options]="timezoneOptions()"
              [keys]="timezoneKeys"
              [control]="timezoneControl"
            ></dropdown>
          } @else {
            <div class="text-xs text-center pl-1 text-[var(--text-nav-secondary)] flex-col gap-2">
              <p>Timezone</p>
              <p>{{ currentTimezoneLabel() }}</p>
            </div>
          }
        </div>
      }

      <div
        #menuWrapper
        class="flex mx-4 my-2 items-center cursor-pointer"
        (click)="toggleDropdown()"
        (keypress)="toggleDropdown()"
        tabindex="1"
      >
        @if (role === 'Admin') {
          <svg-icon class="mx-2" name="avatar_admin" size="XL" color="var(--text-primary)"></svg-icon>
        }

        @if (role === 'Admin' || role === 'User') {
          <span class="text-center">
            <p class="font-bold text-sm text-nowrap">{{ accountName }}</p>
            <p
              class="text-xs italic"
              [ngClass]="{
                'text-[var(--accent-warning)]': membershipStatus === 'ATTENTION' && status !== 4,
                'text-[var(--accent-error)]': membershipStatus === 'GRACE_ZONE',
                'text-[var(--accent-success)]': membershipStatus === 'ACTIVE' || status === 4,
              }"
            >
              {{ currentMembership ? currentMembership.membership.title : role }}
            </p>
          </span>
        }

        @if (showDropdown) {
          <ul
            class="absolute z-100 top-[61px] right-[20px] bg-[var(--bg-dropdown-primary)] border-[1px] border-[var(--header-border)] rounded-md px-4 py-2 z-10"
            [ngClass]="{ 'mr-[8%]': !isAdmin }"
          >
            @for (item of displayedOptions; track item.action; let i = $index) {
              <li
                class="flex items-center border-b-[1px] border-[var(--header-border)] font-medium py-2 first-of-type:pt-0 last-of-type:pb-0 last-of-type:border-0"
                (click)="performAction(item.action)"
                (keypress)="performAction(item.action)"
                [tabindex]="i"
              >
                @if (item.icon) {
                  <svg-icon class="mr-2" [name]="item.icon" size="SM" color="var(--text-primary)"></svg-icon>
                }
                {{ item.option }}
              </li>
            }
          </ul>
        }
      </div>
    </div>
  }
</header>
